import React, { useState } from "react";
import { AnimatePresence, motion, useReducedMotion } from "framer-motion";
import { PlusIcon } from "lucide-react";
import { faqs } from "../data/content";
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  const reduce = useReducedMotion();
  return <section id="faq" className="bg-ink-2 px-6 py-20 sm:py-28" data-id="element-20" data-mp="1gd7gc7wyl95h">
      <div className="mx-auto grid max-w-6xl gap-10 lg:grid-cols-[5fr_7fr] lg:gap-20" data-id="element-21" data-mp="1gausje4is4ki">
        <div className="lg:sticky lg:top-28 lg:self-start" data-id="element-22" data-mp="2dyd9hc8c4czl">
          <p className="mb-4 text-sm font-semibold text-gold" data-id="element-23" data-mp="292eh7djvyatw">Preguntas frecuentes</p>
          <h2 className="font-serif text-[clamp(30px,4.5vw,46px)] font-bold leading-tight" data-id="element-24" data-mp="241h0z6ifrqv1">Lo que más me preguntan</h2>
        </div>

        <div className="border-t border-ink-4" data-id="element-25" data-mp="1z2nit0s7fboj">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <div key={f.q} className="border-b border-ink-4" data-id="element-26" data-mp="noa16do1nsgy" data-mpi={i}>
                <h3 data-id="element-27" data-mp="nmp8ktlaijlq">
                  <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-${i}`} className="flex w-full items-center justify-between gap-6 py-6 text-left focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold" data-id="element-28" data-mp="phy1bk0oa1tw">
                    <span className="font-serif text-[17px] font-bold leading-snug text-white" data-id="element-29" data-mp="6rgbpob4zmcr">{f.q}</span>
                    <PlusIcon className={`h-5 w-5 shrink-0 text-gold transition-transform duration-200 ease-out ${isOpen ? "rotate-45" : ""}`} aria-hidden="true" data-id="element-30" data-mp="bhwpj9ivd9zn" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-31" data-mp="1q969vwguz99">
                  {isOpen && <motion.div id={`faq-${i}`} role="region" initial={reduce ? false : {
                height: 0,
                opacity: 0
              }} animate={{
                height: "auto",
                opacity: 1
              }} exit={reduce ? {
                opacity: 0
              } : {
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-32" data-mp="3jyrtytfbf2fu">
                      <p className="max-w-xl pb-6 text-[15px] leading-[1.8] text-soft" data-id="element-33" data-mp="1ft9kc4nekgjp">{f.a}</p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}